module.exports = __webpack_public_path__ + "static/media/gray-laptop-computer-showing-html-codes-in-shallow-focus-160107.4d0c761f.jpg";